import type React from 'react';
import Text from '@zg-rentals/multibrand-ui/lib/Text';
import { Button, Container, SpacerRow } from '@zg-rentals/multibrand-ui';
import Section from '@rental-manager/components/Section';
import Modal from '@common/components/Modal';
import userPersonas from '@common/constants/userPersonas';
import ProblemTriangle from '@zg-rentals/multibrand-ui/lib/icons/ProblemTriangle';
import { ExpandableDisclaimer } from '@zillow/zrs-comet';
import type { IStyledTextModel } from '@rental-manager/models/Types';

type RentalProtectionDisclaimers = Array<IStyledTextModel>;

type Props = {
  onClose: () => void;
  onContinue: () => void;
  onBack?: () => void;
  fromDashboard?: boolean;
  rentalProtectionDisclaimers: RentalProtectionDisclaimers;
};

const DifferentPaymentTermThanLeaseWarning: React.FC<React.PropsWithChildren<Props>> = (
  props: Props,
): React.ReactElement => {
  return (
    <Modal
      persona={userPersonas.LANDLORD}
      header="Payment setup"
      onRequestClose={props.onClose}
      onClickBack={props.fromDashboard ? props.onBack : null}
      dataAutoTestId="landlord-rental-protection-payment-term-differ-from-lease"
    >
      {
        <Container>
          <Section>
            <ProblemTriangle className="centeredImg" colorType="action" size="lg" />
          </Section>
          <Section>
            <Text type="h5" className="txtC boldText zillowInsuranceSubHeading">
              Zillow Insurance Services
            </Text>
            <Text type="h4" className="txtC boldText">
              Payment term is different than the lease duration
            </Text>
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <Text>
              The payment term you entered is different than the start and end dates in the lease you selected.
            </Text>
            <SpacerRow size="sm" />
            <Text>
              Rent payments through Zillow are required under Rental Protection coverage.&nbsp;
              <strong>
                If you continue with this payment term, your ability to make a Rental Protection claim may be affected.
              </strong>
            </Text>
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <ExpandableDisclaimer disclaimerContent={props.rentalProtectionDisclaimers} title="Legal Disclaimer" />
          </Section>
          <SpacerRow size="sm" />
          <Section>
            <Button onClick={props.onBack} type="primary" full>
              Change payment term
            </Button>
          </Section>
          <Section>
            <Button onClick={props.onContinue} type="secondary" full>
              Continue
            </Button>
          </Section>
        </Container>
      }
    </Modal>
  );
};

export default DifferentPaymentTermThanLeaseWarning;
